// extracted by mini-css-extract-plugin
export default {"starRatingContainer":"StarRating_starRatingContainer__JWXL8"};